import './styles.scss'
import Lottie from 'lottie-react'
import { useTranslation } from 'react-i18next'

const WeatherNoDataCard = ({ weatherTypeData, weatherType, currentCity, type, getWeatherConditionIcon }) => {
  const { t } = useTranslation()

  return (
    <>
      {weatherType && <div className={`${weatherTypeData[weatherType].classNameContainer}`}>{weatherTypeData[weatherType].classNameButton && <button className={`${weatherTypeData[weatherType].classNameButton}`}>{weatherTypeData[weatherType].header}</button>}</div>}
      <div className="weather-card no-data-card">
        <div className="no-data-icon">
          {type === 'other-locations' ? (
            <i className="pi pi-search" />
          ) : (
            (() => {
              const icon = getWeatherConditionIcon('Cloudy')

              return typeof icon === 'string' ? <img src={icon} alt="Weather" className="weather-animation" /> : <Lottie animationData={icon} loop={true} className="weather-animation" />
            })()
          )}
        </div>
        {type === 'other-locations' ? (
          <div className="no-data-message">{t('PLEASE_SEARCH_AND_ADD_A_LOCATION_TO_GET_STARTED')}</div>
        ) : (
          <p className="no-data-message">
            {weatherTypeData[weatherType].body}
            <strong>{currentCity}</strong>
          </p>
        )}
      </div>
    </>
  )
}

const OtherLocationsNoDataCard = ({ duration, searchQuery }) => {
  const { t } = useTranslation()

  return (
    <>
      {duration && (
        <>
          <div className={`${duration === 'FortNight' ? 'forecast-header' : 'today-forecast-btn-container'}`}>
            <button className={`${duration === 'FortNight' ? 'forecast-header-button' : 'today-forecast-btn'}`}>{duration === 'FortNight' ? '10 DAYS FORECAST' : 'HOURLY FORECAST'}</button>
          </div>
        </>
      )}
      <div className="weather-card no-data-card">
        <div className="no-data-icon">
          <i className="pi pi-search" />
        </div>
        <p className="no-data-message">
          {!searchQuery && (
            <>
              Please search and add a location to get <strong>{duration === 'FortNight' ? 'Weather Forecast' : 'Hourly Forecast'}</strong> data.
            </>
          )}
          {searchQuery && <span className="no-data-message-search">{t('NO_RESULTS_FOUND_FOR_YOUR_SEARCH_QUERY')}</span>}
        </p>
      </div>
    </>
  )
}

const LocationNoDataCard = () => {
  const { t } = useTranslation()

  return (
    <div className="weather-card no-data-card">
      <div className="no-data-icon">
        <i className="pi pi-search" />
      </div>
      <div className="no-data-message">{t('PLEASE_SEARCH_AND_ADD_A_LOCATION_TO_GET_STARTED')}</div>
    </div>
  )
}

export { WeatherNoDataCard, OtherLocationsNoDataCard, LocationNoDataCard }
